export default __webpack_public_path__ + "static/media/LAS0050.34I-43316_-25938_0.52a86be3.jpg";